import { Alert } from "@material-ui/lab";
import { Link } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import React, { FC, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  infoAlert: {
    "& .MuiAlert-icon": {
      color: "#B8E7FB",
    },
    marginTop: "20px",
    backgroundColor: "#233145",
  },
})

type PropsType = {
  text: string
}

const AlertSearch: FC<PropsType> = ({text}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [currentText, setCurrentText] = useState<string>(text)
  return (
    <Alert className={classes.infoAlert} severity="info">
      We couldn't find any matches for {currentText}
    </Alert>
  )
}

export default AlertSearch
